var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-pr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M51.624 0h708.66v708.66H51.624z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-37.298) scale(.72249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed0000",
    d: "M0 0h1063v708.66H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 141.73h1063v141.73H0zM0 425.2h1063v141.73H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l609.96 353.88L0 707.3V0z",
    fill: "#0050f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.179 450.475l-65.671-49.041-65.35 49.523 24.305-80.478-65.23-49.695 80.701-.692 25.031-80.234 25.567 80.049 80.701.105-64.895 50.164 24.841 80.3z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.00f681ed96fef0597aa95a44812f6b22.svg";
export { ForwardRef as ReactComponent };